import InvestmentWizardMicrofrontend from './InvestmentWizardMicrofrontend';

export default InvestmentWizardMicrofrontend;
